import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AppState } from '../app-reducers';

import { GTMEventsCrash } from '../../shared/enums/Crashlytics';
import { TENDERO_ENDPOINTS } from '../../shared/models/Constants';
import { IRespGetModal } from '../../shared/models/PopUp.interface';
import { CrashlyticsService } from '../../shared/services/crashlytics/crashlytics.service';
import { SharedServiceService } from '../../shared/services/shared-service.service';
import {
    statusModal,
    successStatusModal,
    errorStatusModal,
    updateModal,
    successUpdateModal,
    errorUpdateModal,
} from '../actions/popup.actions';

@Injectable()
export class PopUpEffects {
    constructor(
        private actions$: Actions
        , private crashlytics: CrashlyticsService
        , private httpS: SharedServiceService
        , private store: Store<AppState>
    ) { }

    /**
     * Consulta modal de promociones
     */
    public statusModal$ = createEffect(() => this.actions$
        .pipe(
            ofType(statusModal),
            switchMap(
                actions => this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.get_popup_status, actions)
                    .pipe(
                        map((resp: IRespGetModal) => successStatusModal(resp)),
                        catchError((err: Error) => {
                            this.crashlytics.sendCrashPlatform(GTMEventsCrash.statusModalApi, err).then(() => { });
                            return of(errorStatusModal({ payload: err }));
                        })
                    ))
        ));

    public updateModal$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateModal),
            withLatestFrom(this.store.select(state => state.Modal.GetStatus.idTenderopopup)),
            switchMap(([action, idTenderoPopUp]) =>
                this.httpS.executeRequestByUser(TENDERO_ENDPOINTS.post_tendero_popup, { ...action, ID_TenderoPopUp: idTenderoPopUp })
                    .pipe(
                        map((resp) => successUpdateModal(resp)),
                        catchError((err: Error) => {
                            this.crashlytics.sendCrashPlatform(GTMEventsCrash.updateModalApi, err).then(() => { });
                            return of(errorUpdateModal({ payload: err }));
                        })
                    )
            )
        )
    );

}
